window.VARIANT_PICKER_INFO = {
  variant: "{{ default_variant.id }}", // Default variant ID for 3 months
  purchase_mode: "subscription",
  ot_sale_price: "{{ default_variant.price | money_without_trailing_zeros }}",
  ot_compare_price:
    "{{ default_variant.compare_at_price | money_without_trailing_zeros }}",
  subs_compare_price:
    "{{ default_variant.compare_at_price | money_without_trailing_zeros }}",
  subscription_price:
    "{{ default_variant.price | money_without_trailing_zeros }}",
  subscrption_plan: "{{ default_variant.metafields.custom.subscription_plan }}",
  save_note: "{{ default_variant.metafields.custom.save_note }}",
  supply_note: "{{ default_variant.metafields.custom.supply_note }}",
  bundle_qty: "{{default_variant.metafields.custom.bundle_qty}}",
  bundle_price: "{{ default_variant.metafields.custom.variant_display_price.value | money_without_trailing_zeros }}",
};

// Function to update the product form with selected variant
function updateProductForm() {
  let selectedMode = document
    .querySelector(".plan-select-box.active")
    .getAttribute("mode");
  let selectedVariant;
  let selectedVariantQty;
  let subsUspTitles = document.querySelectorAll(".subs-usp-title");
 
  if (selectedMode === "subscription") {
    selectedVariant = document
      .querySelector(".variant-item-box.active")
      .getAttribute("active-subscription-plan");
   
  } else if (selectedMode === "one_time") {
    selectedVariant = document
      .querySelector(".variant-item-box.active")
      .getAttribute("variant-id");
    
  }
  selectedVariantQty = document
      .querySelector(".variant-item-box.active")
      .getAttribute("bundle_qty");

    //console.log(window.VARIANT_PICKER_INFO.bundle_qty,selectedVariantQty);
  if (selectedVariant) {
    document.querySelector(".product-variant-id").value = selectedVariant;
    //document.querySelector(".subs-usp-title").value = selectedVariantQty;
    //document.querySelector(".product-bundle-qty").value = selectedVariantQty;
      let monthAbbr = selectedVariantQty == "1" ? " month" : " months";
     subsUspTitles.forEach(element => {
       let subUspStr = element.getAttribute("data-sub-usp-text");
       //console.log(subUspStr);
      element.innerHTML = subUspStr.replace(/{{MONTH}}/g, selectedVariantQty + monthAbbr);
  });
   
  }
}

// Set default selection on page load
document.addEventListener("DOMContentLoaded", function () {
  let defaultVariant = document.querySelector(
    '.variant-item-box[variant-id="3"]'
  );
  let defaultPlan = document.querySelector(
    '.plan-select-box[mode="subscription"]'
  ); // Assuming "subscription" means 3 months

  if (defaultVariant) {
    defaultVariant.classList.add("active");
  }

  if (defaultPlan) {
    defaultPlan.classList.add("active");
  }

  variant_box_update();
  updateProductForm(); // Ensure form updates on load
});

function variant_box_update() {
  let activeVariant = document.querySelector(".variant-item-box.active");
  let activePlan = document.querySelector(".plan-select-box.active");

  if (activeVariant) {
    window.VARIANT_PICKER_INFO.variant =
      activeVariant.getAttribute("variant-id");
    window.VARIANT_PICKER_INFO.ot_sale_price =
      activeVariant.getAttribute("sale-price");
    window.VARIANT_PICKER_INFO.ot_compare_price = activeVariant.getAttribute(
      "one-time-compare-price"
    );
    window.VARIANT_PICKER_INFO.subs_compare_price = activeVariant.getAttribute(
      "subscription-compare-price"
    );
    window.VARIANT_PICKER_INFO.subscription_price =
      activeVariant.getAttribute("subscription-price");
    window.VARIANT_PICKER_INFO.subscrption_plan = activeVariant.getAttribute(
      "active-subscription-plan"
    );
    window.VARIANT_PICKER_INFO.save_note =
      activeVariant.getAttribute("save_note");
    window.VARIANT_PICKER_INFO.supply_note =
      activeVariant.getAttribute("supply_note");
    window.VARIANT_PICKER_INFO.bundle_qty =
      activeVariant.getAttribute("bundle_qty");

    let activeJarText =
      activeVariant.querySelector(".variant-option-title")?.textContent || "";
    let planSubheading = document.querySelector(
      "#variant-picker-box .one-time-box.plan-select-box .plan-subheading"
    );
    if (planSubheading) {
      planSubheading.textContent = `${activeJarText} shipped once`;
    }
  }

  if (activePlan) {
    window.VARIANT_PICKER_INFO.purchase_mode = activePlan.getAttribute("mode");
  }

  document
    .querySelectorAll(".subscription-plan-box.plan-select-box .sale-price")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.subscription_price;
    });

  document
    .querySelectorAll(".subscription-plan-box.plan-select-box .compare-price")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.ot_compare_price;
    });

  document
    .querySelectorAll(".one-time-box.plan-select-box .sale-price")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.ot_sale_price;
    });

  document
    .querySelectorAll(".one-time-box.plan-select-box .one-time-compare-price")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.ot_compare_price;
    });
  document
    .querySelectorAll(
      ".subscription-plan-box.plan-select-box .subscription-compare-price"
    )
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.subs_compare_price;
    });
  document
    .querySelectorAll(".subscription-plan-box.plan-select-box .supply_note")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.supply_note;
    });
  document
    .querySelectorAll(".subscription-plan-box.plan-select-box .save_note")
    .forEach((el) => {
      el.textContent = window.VARIANT_PICKER_INFO.save_note;
    });

  updateProductForm(); // Update form whenever variant changes
}

document.querySelectorAll(".plan-box-header").forEach((header) => {
  header.addEventListener("click", function () {
    let parentWrapper = this.closest(".plan-select-box-wrapper");
    if (parentWrapper) {
      parentWrapper
        .querySelectorAll(".plan-select-box")
        .forEach((box) => box.classList.remove("active"));
    }
    this.closest(".plan-select-box").classList.add("active");
    variant_box_update();
  });
});

document.querySelectorAll(".variant-item-box").forEach((variant) => {
  variant.addEventListener("click", function () {
    let parentWrapper = this.closest(".variant-picker-box-wrapper");
    if (parentWrapper) {
      parentWrapper
        .querySelectorAll(".variant-item-box")
        .forEach((box) => box.classList.remove("active"));
    }
    this.classList.add("active");
    variant_box_update();
  });
});
